import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '../../components/ui/dialog';
import { CalendarDays, Plus, Save, Trash2, Send, Gift, Mail } from 'lucide-react';
import { ImageUploader } from '../../components/ImageUploader';

export const EventsTab = ({
  events, customers, showNewEvent, setShowNewEvent, newEvent, setNewEvent,
  createEvent, deleteEvent, sendEventEmails, sendBirthdayEmails,
}) => {
  const typeColors = { happy_hour: 'bg-[#E9C46A] text-[#2D241D]', event: 'bg-[#0A422D] text-white', promo: 'bg-[#E16833] text-white' };
  const typeLabels = { happy_hour: 'Happy Hour', event: 'Evenement', promo: 'Promotion' };

  return (
    <>
      <div className="bg-white rounded-2xl p-4 border border-[#E5DCD3] mb-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <div>
          <h3 className="font-semibold text-[#2D241D]">Evenements & Promotions ({events.length})</h3>
          <p className="text-xs text-[#6E5E52]">Happy Hour, soirees, promos - envoyez par email aux clients</p>
        </div>
        <div className="flex gap-2">
          <Button onClick={sendBirthdayEmails} variant="outline"
            className="rounded-xl border-[#E5DCD3] text-[#6E5E52] text-sm" data-testid="send-birthday-emails">
            <Gift className="w-4 h-4 mr-1" /> Anniversaires du jour
          </Button>
          <Dialog open={showNewEvent} onOpenChange={setShowNewEvent}>
            <DialogTrigger asChild>
              <Button className="bg-[#E16833] hover:bg-[#C95A2A] text-white rounded-xl" data-testid="add-event-btn">
                <Plus className="w-4 h-4 mr-2" /> Creer
              </Button>
            </DialogTrigger>
            <DialogContent className="max-w-lg bg-white rounded-3xl admin-theme !p-0" style={{maxHeight:'85vh',display:'flex',flexDirection:'column',top:'50%',left:'50%',transform:'translate(-50%,-50%)',position:'fixed'}}>
              <DialogHeader className="flex-shrink-0 px-6 pt-6 pb-3"><DialogTitle className="text-[#2D241D]">Nouvel evenement</DialogTitle></DialogHeader>
              <div className="space-y-4 px-6 pb-6 overflow-y-auto flex-1 min-h-0 overscroll-contain" style={{WebkitOverflowScrolling:'touch'}}>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm font-medium text-[#2D241D] mb-1 block">Titre (EN)</label>
                    <Input value={newEvent.title} onChange={(e) => setNewEvent({ ...newEvent, title: e.target.value })}
                      placeholder="Happy Hour" className="rounded-xl border-[#E5DCD3]" data-testid="event-title" />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-[#2D241D] mb-1 block">Titre (FR)</label>
                    <Input value={newEvent.title_fr} onChange={(e) => setNewEvent({ ...newEvent, title_fr: e.target.value })}
                      placeholder="Happy Hour" className="rounded-xl border-[#E5DCD3]" data-testid="event-title-fr" />
                  </div>
                </div>
                <div>
                  <label className="text-sm font-medium text-[#2D241D] mb-1 block">Description (FR)</label>
                  <Textarea value={newEvent.description_fr} onChange={(e) => setNewEvent({ ...newEvent, description_fr: e.target.value })}
                    placeholder="Tous les cocktails a -50%..." className="rounded-xl border-[#E5DCD3] min-h-[60px]" rows={2} data-testid="event-desc" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                  <div>
                    <label className="text-sm font-medium text-[#2D241D] mb-1 block">Type</label>
                    <select value={newEvent.event_type} onChange={(e) => setNewEvent({ ...newEvent, event_type: e.target.value })}
                      className="w-full h-10 rounded-xl border border-[#E5DCD3] px-3 bg-white text-sm" data-testid="event-type">
                      <option value="event">Evenement</option>
                      <option value="happy_hour">Happy Hour</option>
                      <option value="promo">Promotion</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-[#2D241D] mb-1 block">Date</label>
                    <Input type="date" value={newEvent.date} onChange={(e) => setNewEvent({ ...newEvent, date: e.target.value })}
                      className="rounded-xl border-[#E5DCD3]" data-testid="event-date" />
                  </div>
                  <div>
                    <label className="text-sm font-medium text-[#2D241D] mb-1 block">Horaires</label>
                    <Input value={newEvent.time_range} onChange={(e) => setNewEvent({ ...newEvent, time_range: e.target.value })}
                      placeholder="16:00-19:00" className="rounded-xl border-[#E5DCD3]" data-testid="event-time" />
                  </div>
                </div>
                <ImageUploader value={newEvent.image_url}
                  onChange={(url) => setNewEvent({ ...newEvent, image_url: url })}
                  label="Image ou affiche" allowPdf={true} />
                <label className="flex items-center gap-2 cursor-pointer bg-[#FFF3E0] p-3 rounded-xl">
                  <input type="checkbox" checked={newEvent.send_email}
                    onChange={(e) => setNewEvent({ ...newEvent, send_email: e.target.checked })}
                    className="w-4 h-4 rounded" />
                  <Mail className="w-4 h-4 text-[#E16833]" />
                  <span className="text-sm text-[#2D241D] font-medium">Envoyer par email ({customers.length} clients)</span>
                </label>
                <div className="pb-2">
                  <Button onClick={createEvent} disabled={!newEvent.title}
                    className="w-full bg-[#E16833] hover:bg-[#C95A2A] text-white rounded-xl" data-testid="save-event-btn">
                    <Save className="w-4 h-4 mr-2" /> Creer l'evenement
                  </Button>
                </div>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>

      <div className="space-y-3">
        {events.map(evt => (
          <div key={evt.id} className="bg-white rounded-2xl p-4 border border-[#E5DCD3]" data-testid={`event-${evt.id}`}>
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${typeColors[evt.event_type] || typeColors.event}`}>
                    {typeLabels[evt.event_type] || evt.event_type}
                  </span>
                  {evt.date && <span className="text-xs text-[#6E5E52]">{evt.date}</span>}
                  {evt.time_range && <span className="text-xs text-[#E16833]">{evt.time_range}</span>}
                </div>
                <h4 className="font-semibold text-[#2D241D]">{evt.title_fr || evt.title}</h4>
                {evt.description_fr && <p className="text-sm text-[#6E5E52] mt-1">{evt.description_fr}</p>}
              </div>
              <div className="flex gap-1 ml-3">
                <Button size="sm" variant="ghost" onClick={() => sendEventEmails(evt.id)}
                  className="text-[#E16833] hover:text-[#E16833]" data-testid={`send-email-${evt.id}`}>
                  <Send className="w-4 h-4" />
                </Button>
                <Button size="sm" variant="ghost" onClick={() => deleteEvent(evt.id)}
                  className="text-[#E63946] hover:text-[#E63946]" data-testid={`delete-event-${evt.id}`}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </div>
          </div>
        ))}
        {events.length === 0 && (
          <div className="text-center py-12 text-[#6E5E52]">
            <CalendarDays className="w-12 h-12 mx-auto mb-3 opacity-30" />
            <p>Aucun evenement</p>
          </div>
        )}
      </div>
    </>
  );
};
